import { Label } from "@/components/ui/label";
import { RadioGroupItem } from "@/components/ui/radio-group";
import { LucideIcon } from "lucide-react";
import { InsuranceType } from "./types";

interface InsuranceTypeCardProps {
  value: InsuranceType;
  label: string;
  icon: LucideIcon;
  description: string;
  isSelected: boolean;
}

const InsuranceTypeCard = ({
  value,
  label,
  icon: Icon,
  description,
  isSelected,
}: InsuranceTypeCardProps) => {
  return (
    <div>
      <RadioGroupItem
        value={value}
        id={value}
        className="peer hidden"
      />
      <Label
        htmlFor={value}
        className={`flex flex-col items-center p-6 bg-white border-2 rounded-lg cursor-pointer transition-all hover:border-primary hover:shadow-md
          ${isSelected 
            ? 'border-primary bg-primary/5 ring-2 ring-primary ring-offset-2' 
            : 'border-gray-200'
          }`}
      >
        <div className={`w-12 h-12 rounded-full flex items-center justify-center mb-4 transition-colors
          ${isSelected ? 'bg-primary' : 'bg-primary/10'}`}>
          <Icon className={`w-6 h-6 ${isSelected ? 'text-white' : 'text-primary'}`} />
        </div>
        <h4 className="text-lg font-semibold text-primary-dark mb-2">
          {label}
        </h4>
        <p className="text-neutral text-sm text-center">
          {description}
        </p>
      </Label>
    </div>
  );
};

export default InsuranceTypeCard;